export default class BaseService {
  code: string;
	dailyCost: number;
  expectedValue: number;
	disabled: boolean;
  months: number;
	name: string;
	tooltip?: string;
  percentage: number;

  constructor() {
    this.expectedValue = 0;
    this.name = '';
    this.months = 0;
    this.disabled = false;
    this.percentage = 0;
  }
}
